'use client';

import { useEffect, useRef } from 'react';
import { getENV, useEffectOnce, useLoyaltyContext, usePageLayout } from '@libs/common-next';
import { trackUserAuthentication } from '../../gtm';
import { PageViewTracking } from '../PageViewTracking';
import { gtmConfig } from '../../constants/config';

export function NoScriptIframe() {
    const { gtmAuth, gtmPreview, gtmContainerId } = gtmConfig[getENV('NEXT_PUBLIC_LOCALE') == 'en-CA' ? 'ca' : 'us'];

    return (
        <noscript>
            <iframe
                title="gtm-noscript"
                src={`https://www.googletagmanager.com/ns.html?id=${gtmContainerId}&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x`}
                height="0"
                width="0"
                style={{ display: 'none', visibility: 'hidden' }}
            />
        </noscript>
    );
}

export function GtmPageViewTracker() {
    const { ocapi, loyalty, isAuthenticated, user, userData } = usePageLayout();
    const { memberPoints } = useLoyaltyContext();
    const shouldTriggerUserAuthenticationEventRef = useRef(true);

    // TODO: remove effect after go-live
    // Track user authentication for legacy login (page load)
    useEffect(() => {
        const { customer } = ocapi?.data?.session ?? {};
        if (
            customer &&
            customer.auth_type !== 'guest' &&
            customer.c_loyaltyId &&
            loyalty &&
            shouldTriggerUserAuthenticationEventRef.current
        ) {
            trackUserAuthentication({
                loyaltyId: customer.c_loyaltyId,
                storeId: customer.c_storeID ?? null,
                totalTreatsPoints: loyalty.totalPoints ?? 0,
                loginState: true,
            });
            shouldTriggerUserAuthenticationEventRef.current = false;
        }
    }, [ocapi?.data?.session, loyalty]);

    // Track user authentication for velocity login (page load)
    useEffect(() => {
        if (isAuthenticated === 'velocity' && memberPoints && shouldTriggerUserAuthenticationEventRef.current) {
            trackUserAuthentication({
                loyaltyId: user?.loyaltyid?.toString() ?? '',
                storeId: userData?.profile?.storeNumber ?? null,
                totalTreatsPoints: memberPoints?.availablePoints ?? 0,
                loginState: true,
            });
            shouldTriggerUserAuthenticationEventRef.current = false;
        }
    }, [isAuthenticated, memberPoints, user, userData]);

    useEffect(() => {
        if (!isAuthenticated) {
            shouldTriggerUserAuthenticationEventRef.current = true;
        }
    }, [isAuthenticated]);

    useEffectOnce(() => {
        window.flags = {
            ...window.flags,
            IS_PERFORMANCE_MODE: process.env.NEXT_PUBLIC_PERFORMANCE_MODE === 'true',
        };
    });

    return (
        <>
            <NoScriptIframe />
            <PageViewTracking />
        </>
    );
}
